module.exports = __webpack_public_path__ + "img/FJ.902a5149.svg";